/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconClockHour9 = createReactComponent("outline", "clock-hour-9", "IconClockHour9", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12h-3.5", "key": "svg-1" }], ["path", { "d": "M12 7v5", "key": "svg-2" }]]);

export { IconClockHour9 as default };
//# sourceMappingURL=IconClockHour9.mjs.map
